import {ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {addDriversApi, assignBusToDriver, editDriverApi, getDriverApi, getDriversApi, removeDriverApi} from '../api/drivers';
import {editBusApi, getBusesApi} from '../api/bus';
import {uplodeImage} from '../api/util';
import swal from "sweetalert2";

@Component({
  selector: 'app-drivers',
  templateUrl: './drivers.component.html',
  styleUrls: ['./drivers.component.css']
})
export class DriversComponent implements OnInit {

  constructor(private _fb: FormBuilder,private _cd:ChangeDetectorRef) { }

  data: FormGroup;
  drivers = [];
  buses = [];
  driverBus=[]
  editMode = false;
  imageUplode=false

  selectedBus = [];
  unSelectedBus = [];
  archiveDrivers = [];
  p: number = 1;
  p2: number = 1;

  loader=true
  selectedDriver = {};
  profileImg="../../assets/images/profile-square.jpg"
  ngOnInit() {

    this.data = this._fb.group({
      name: ['', Validators.required],
      national: ['اردني', Validators.required],
      university: null,
      phone: ['', Validators.required],
      profile_photo: [null],
      birthday: [''],
      address: [''],
      date_end: ['', Validators.required],
      driver_license: ['', Validators.required],
      license_type: ['', Validators.required],
      ssi: ['', Validators.required],
      password: ['', Validators.required],
    });
    this.getDrivers();
    this.getBuses();
    this.getArchiveDrivers()
  }

  async getBuses() {
    const result = await getBusesApi("withDrivers=false");

    if (result) {
      this.buses = [];
      this.buses = result.data.data;



    }

  }
  changeEditMode() {
    this.editMode = false;
    this.data = this._fb.group({
      name: ['', Validators.required],
      national: ['اردني', Validators.required],
      university: null,
      phone: ['', Validators.required],
      profile_photo: [''],
      birthday: [''],
      address: [''],
      date_end: ['', Validators.required],
      driver_license: ['', Validators.required],
      license_type: ['', Validators.required],
      ssi: ['', Validators.required],
      password: ['', Validators.required],
    });
  }


  changeImage(input) {
    console.log('sss', input);
    let reader;
    if (input.target.files) {
      reader = new FileReader();

      reader.onload = (e) => {
        console.log(e.target.result);
        this.imageUplode=true

        this.data.get('profile_photo').setValue(e.target.result);
        this.profileImg=e.target.result
        // preview.setAttribute('src', e.target.result);
      }

      reader.readAsDataURL(input.target.files[0]);
    }
  }

  async edit() {
    const data = this.data.value;
    if (this.imageUplode) {
      const img = data.profile_photo;
      const uplode = await uplodeImage(img);
      if (uplode) {

        data.profile_photo = uplode.data;
      }
    }
    data.phone="+962"+data.phone


    const result = await editDriverApi(data, this.selectedDriver['_id']);

    if (result) {
      swal(
        'تم انتهاء  العملية بنجاح',
        '',

        'success'
      )
      this.getDrivers();
    }else {
      swal(
        'حصل خطأ، يرجى المحاولة مرة أخرى',
        '',

        'error'
      )
    }


    console.log(this.data.value);
  }
  async ActiveDriver(id) {
    const data = {
      disabled:false
    };


    const result = await editDriverApi(data, id);

    if (result) {
      swal(
        'تم انتهاء  العملية بنجاح',
        '',

        'success'
      )
      this.getDrivers();
      this.getArchiveDrivers();
    }else {
      swal(
        'حصل خطأ، يرجى المحاولة مرة أخرى',
        '',

        'error'
      )
    }


    console.log(this.data.value);
  }
  async getDrivers() {
    const result = await getDriversApi();
    this.loader=true
this.profileImg="../../assets/images/profile-square.jpg"

    this.editMode = false;
    if (result) {
      this.profileImg="../../assets/images/profile-square.jpg"
      this.loader=false
      this.drivers = [];
      this.drivers = result.data.data;
this.selectedDriver={}
this.unSelectedBus=[]
      this.selectedBus=[]
      this.data = this._fb.group({
        name: ['', Validators.required],
        national: ['اردني', Validators.required],
        university: null,
        phone: ['', Validators.required],
        profile_photo: [null],
        birthday: [''],
        address: [''],
        date_end: ['', Validators.required],
        driver_license: ['', Validators.required],
        license_type: ['', Validators.required],
        ssi: ['', Validators.required],
        password: ['', Validators.required],
      });


    }

  }
  async getArchiveDrivers() {
    const result = await getDriversApi("true");

    if (result) {
this.archiveDrivers=result.data.data

    }

  }


  async getDriver(id) {
    const result = await getDriverApi(id);
    this.editMode = true;

    if (result) {

      const driver = result.data.data;
      this.selectedDriver = driver;
      driver.phone=driver.phone.replace("+962","")

      this.data = this._fb.group({
        name: [driver.name, Validators.required],
        national: [driver.national, Validators.required],
        university: [driver.university],
        phone: [driver.phone, Validators.required],
        profile_photo: [driver.profile_photo],
        birthday: [driver.birthday, Validators.required],
        address: [driver.address, Validators.required],
        date_end: [driver.date_end, Validators.required],
        driver_license: [driver.driver_license, Validators.required],
        license_type: [driver.license_type, Validators.required],
        ssi: [driver.ssi, Validators.required],
        password: [driver.password, Validators.required],
      });

      this.profileImg=driver.profile_photo?driver.profile_photo:this.profileImg

    }

  }

  selectedRow(row) {
    this.selectedDriver={}
    this.selectedDriver = row;

    this.selectedBus = [];
    this.unSelectedBus=[]

this.selectedBus=row['bus_id']
// this.buses.filter(o => {if (o.drivers_id.includes(row._id)) {    this.selectedBus.push( o._id); }});
    console.log(this.selectedBus);
    this.editMode = true;
    console.log(this.selectedDriver)
  }

  async removeDriver(id) {
    const result = await removeDriverApi(id);

    if (result) {

      const driver = result.data.data;
      this.getDrivers();
      this.getBuses()
      this.getArchiveDrivers();

      swal(
        'تم انتهاء  العملية بنجاح',
        '',

        'success'
      )

    }else {
      swal(
        'حصل خطأ، يرجى المحاولة مرة أخرى',
        '',

        'error'
      )
    }

  }

  assignToBus(bus, checked) {
    this.unSelectedBus=this.selectedBus
    this.selectedBus=[]
    this.selectedBus.push(bus);

      // this.selectedBus.push(bus);

    // if (this.selectedBus.includes(bus)) {
    //   this.selectedBus=[]
    //   this.unSelectedBus.push(bus)
    // } else {
    //   this.selectedBus=[]
    //   this.selectedBus.push(bus);
    // }

    console.log(this.selectedBus);
  }




  async add() {
    const data = this.data.value;


    if (this.imageUplode) {
      const img = data.profile_photo;
      const uplode = await uplodeImage(img);
      if (uplode) {

        data.profile_photo = uplode.data;
      }
    }
    data.phone="+962"+data.phone
    console.log('xxxxxxx')

    const result = await addDriversApi(data);
console.log(result)
    if (!result["err"]) {
      this.getDrivers();
      swal(
        'تم انتهاء  العملية بنجاح',
        '',

        'success'
      )
    }else {
      swal(
        result['err'].response.data,
        '',

        'error'
      )
    }


    console.log(this.data.value);
  }



  async saveBus() {
    const data = {selectedBus: this.selectedBus, unSelected: this.unSelectedBus};
    const result = await assignBusToDriver(data, this.selectedDriver['_id']);

    if (result) {
      this.unSelectedBus = [];
      this.selectedBus = [];
      this.selectedDriver={}
      this.getDrivers();
      this.getBuses();

      this._cd.detectChanges()


      swal(
        'تم انتهاء  العملية بنجاح',
        '',

        'success'
      )
    }else {
      swal(
        'حصل خطأ، يرجى المحاولة مرة أخرى',
        '',

        'error'
      )
    }
  }

  openFile() {
    document.getElementById('file').click();
  }

  @ViewChild("search")
  public searchElementRef: ElementRef;
  @ViewChild("search2")
  public searchElementRef2: ElementRef;
  removeSearch() {
    this.searchElementRef.nativeElement.value=""
    this.searchElementRef2.nativeElement.value=""
  }
}
